import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f4187724"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("新增会员")
const _hoisted_2 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"min-width":"60px"} }, "关键字：", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"min-width":"80px","margin-left":"10px"} }, "是否缴费：", -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode("全部")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("是")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("否")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"min-width":"80px","margin-left":"10px"} }, "所属行业：", -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode("全部")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"min-width":"80px","margin-left":"10px"} }, "客户评级:", -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode("全部")
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"min-width":"50px","margin-left":"10px"} }, "时间：", -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("下载模板")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("上传excel")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("导出EXCEL")
const _hoisted_18 = { key: 0 }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("正常")
const _hoisted_20 = { key: 1 }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("已退会")
const _hoisted_22 = { key: 0 }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("已缴费")
const _hoisted_24 = { key: 1 }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("未缴费")
const _hoisted_26 = ["src"]
const _hoisted_27 = { key: 4 }
const _hoisted_28 = { key: 5 }
const _hoisted_29 = { key: 6 }
const _hoisted_30 = { key: 7 }
const _hoisted_31 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_32 = /*#__PURE__*/_createTextVNode("设置状态")
const _hoisted_33 = /*#__PURE__*/_createTextVNode("缴费状态")
const _hoisted_34 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" 上传 ")
const _hoisted_36 = ["src"]
const _hoisted_37 = /*#__PURE__*/_createTextVNode("未知")
const _hoisted_38 = /*#__PURE__*/_createTextVNode("男")
const _hoisted_39 = /*#__PURE__*/_createTextVNode("女")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_icon = _resolveComponent("a-icon")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_card, {
      title: "会员管理",
      style: {"margin-bottom":"16px"},
      bordered: ""
    }, {
      extra: _withCtx(() => [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: $setup.goSet
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_row, { align: "middle" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _hoisted_3,
                  _createVNode(_component_a_input, {
                    value: _ctx.searches.keywords,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searches.keywords) = $event)),
                    placeholder: "输入名字搜索",
                    style: {"width":"200px"}
                  }, null, 8, ["value"]),
                  _hoisted_4,
                  _createVNode(_component_a_select, {
                    value: _ctx.searches.fee_status,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searches.fee_status) = $event)),
                    style: {"width":"150px"},
                    placeholder: "请选择是否缴费"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select_option, { value: "" }, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: 1 }, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: 0 }, {
                        default: _withCtx(() => [
                          _hoisted_7
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"]),
                  _hoisted_8,
                  _createVNode(_component_a_select, {
                    "default-value": "全部",
                    ref: "select",
                    value: _ctx.searches.industry,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searches.industry) = $event)),
                    style: {"width":"150px"},
                    placeholder: "请选择所属行业"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select_option, { value: "" }, {
                        default: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 1
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.industryList, (item, index) => {
                        return (_openBlock(), _createBlock(_component_a_select_option, {
                          key: index,
                          value: item.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["value"]),
                  _hoisted_10,
                  _createVNode(_component_a_select, {
                    "default-value": "全部",
                    ref: "select",
                    value: _ctx.searches.level,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searches.level) = $event)),
                    style: {"width":"150px"},
                    placeholder: "请选择客户评级"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select_option, { value: "" }, {
                        default: _withCtx(() => [
                          _hoisted_11
                        ]),
                        _: 1
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.levelList, (item, index) => {
                        return (_openBlock(), _createBlock(_component_a_select_option, {
                          key: index,
                          value: item.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["value"]),
                  _hoisted_12,
                  _createVNode(_component_a_range_picker, {
                    value: _ctx.searches.time,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searches.time) = $event))
                  }, null, 8, ["value"]),
                  _createVNode(_component_a_button, {
                    type: "primary",
                    onClick: $setup.searchData,
                    style: {"margin-left":"10px"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_13
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_a_button, {
                    type: "dashed",
                    onClick: $setup.resetSearch,
                    style: {"margin-left":"10px"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_14
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { style: {"flex":"1"} }),
            _createVNode(_component_a_col, { class: "member" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  style: {"margin-right":"10px"},
                  onClick: $setup.downloadTemp
                }, {
                  default: _withCtx(() => [
                    _hoisted_15
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_a_upload, {
                  class: "no-list",
                  name: "file",
                  action: "#",
                  fileList: _ctx.result,
                  onChange: $setup.exportData
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, { style: {"margin-right":"10px"} }, {
                      default: _withCtx(() => [
                        _hoisted_16
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["fileList", "onChange"]),
                _createVNode(_component_a_button, {
                  onClick: $setup.exportExcel,
                  style: {"margin-left":"-115px","margin-top":"-33px","position":"absolute"}
                }, {
                  default: _withCtx(() => [
                    _hoisted_17
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_table, {
      "data-source": _ctx.list,
      columns: $setup.columns,
      loading: _ctx.loading,
      bordered: "",
      pagination: $setup.pagination,
      onChange: $setup.handleTableChange,
      scroll: { x:'max-content' }
    }, {
      bodyCell: _withCtx(({ column, text, record }) => [
        (column.key === 'sex')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(text === 0 ? '未知' : text === 1 ? '男' : '女'), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'status')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (text==1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createVNode(_component_a_tag, { color: "#108ee9" }, {
                      default: _withCtx(() => [
                        _hoisted_19
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (text==0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _createVNode(_component_a_tag, { color: "#f50" }, {
                      default: _withCtx(() => [
                        _hoisted_21
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'fee_status')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              (text==1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createVNode(_component_a_tag, { color: "#108ee9" }, {
                      default: _withCtx(() => [
                        _hoisted_23
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (text==0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _createVNode(_component_a_tag, { color: "#f50" }, {
                      default: _withCtx(() => [
                        _hoisted_25
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'logo')
          ? (_openBlock(), _createElementBlock("img", {
              key: 3,
              src: text,
              style: {"width":"40px"}
            }, null, 8, _hoisted_26))
          : _createCommentVNode("", true),
        (column.key === 'leveldata')
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(record.leveldata == null ? '无' :  record.leveldata['name']), 1))
          : _createCommentVNode("", true),
        (column.key === 'Industrydata')
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(record.Industrydata == null ? '无' :  record.Industrydata['name']), 1))
          : _createCommentVNode("", true),
        (column.key === 'join_time')
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString($setup.moment(Number(text + '000')).format('YYYY/MM/DD')), 1))
          : _createCommentVNode("", true),
        (column.key === 'contact_time')
          ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString($setup.moment(Number(text + '000')).format('YYYY/MM/DD')), 1))
          : _createCommentVNode("", true),
        (column.key === 'action')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
              _createVNode(_component_a_button, {
                size: "small",
                onClick: ($event: any) => ($setup.setSortEditItem(record)),
                style: {"margin":"5px"}
              }, {
                default: _withCtx(() => [
                  _hoisted_31
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_a_popconfirm, {
                title: "请设置该会员状态?",
                "ok-text": "正常",
                "cancel-text": "已退会",
                onConfirm: ($event: any) => ($setup.onStatus(record,1)),
                onCancel: ($event: any) => ($setup.onStatus(record,0))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    size: "small",
                    style: {"margin":"5px"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_32
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1032, ["onConfirm", "onCancel"]),
              _createVNode(_component_a_popconfirm, {
                title: "请设置该会员缴费状态?",
                "ok-text": "已缴费",
                "cancel-text": "未缴费",
                onConfirm: ($event: any) => ($setup.onFeed(record,1)),
                onCancel: ($event: any) => ($setup.onFeed(record,0))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    size: "small",
                    style: {"margin":"5px"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_33
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1032, ["onConfirm", "onCancel"]),
              _createVNode(_component_a_popconfirm, {
                title: "是否删除该会员?",
                onConfirm: ($event: any) => ($setup.onDel(record))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    size: "small",
                    style: {"margin":"5px"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_34
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1032, ["onConfirm"])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["data-source", "columns", "loading", "pagination", "onChange"]),
    _createVNode(_component_a_modal, {
      title: _ctx.Title,
      visible: _ctx.visible,
      onOk: _cache[20] || (_cache[20] = ($event: any) => ($setup.onSubmit('formRef'))),
      onCancel: _cache[21] || (_cache[21] = ($event: any) => (_ctx.visible = false)),
      width: "35%"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          ref: "formRef",
          model: _ctx.form,
          rules: $setup.rules,
          "label-col": { span:4 },
          "wrapper-col": { span: 19 },
          autocomplete: "off"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              ref: "company",
              label: "企业名称",
              name: "company"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.form.company,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.company) = $event)),
                  placeholder: "请输入企业名称"
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 512),
            _createVNode(_component_a_form_item, {
              ref: "logo",
              label: "企业logo"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_upload, {
                  name: "file",
                  "file-list": _ctx.fileList,
                  class: "avatar-uploader",
                  headers: $setup.uploadHeaders,
                  action: $setup.uploadAction,
                  data: $setup.uploadFormData,
                  onChange: $setup.handleChange
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createVNode(_component_a_button, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_icon, { type: "upload" }),
                          _hoisted_35
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }, 8, ["file-list", "headers", "action", "data", "onChange"]),
                (_ctx.form.logo != '' )
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.form.logo,
                      style: {"width":"50px","height":"50px","margin-top":"10px"}
                    }, null, 8, _hoisted_36))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 512),
            _createVNode(_component_a_form_item, {
              ref: "website",
              label: "企业官网"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.form.website,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.website) = $event)),
                  placeholder: "请输入企业官网"
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 512),
            _createVNode(_component_a_form_item, {
              ref: "industry",
              label: "所属行业"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  ref: "select",
                  value: _ctx.form.industry,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.industry) = $event)),
                  style: {"width":"100"},
                  placeholder: "请选择所属行业"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.industryList, (item, index) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: index,
                        value: item.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }, 512),
            _createVNode(_component_a_form_item, {
              ref: "level",
              label: "客户评级"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  ref: "select",
                  value: _ctx.form.level,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.level) = $event)),
                  style: {"width":"100"},
                  placeholder: "请选择客户评级"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.levelList, (item, index) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: index,
                        value: item.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }, 512),
            _createVNode(_component_a_form_item, {
              ref: "company_addr",
              label: "企业地址",
              name: "company_addr"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.form.company_addr,
                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.company_addr) = $event)),
                  placeholder: "请输入企业地址"
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 512),
            _createVNode(_component_a_form_item, {
              ref: "intro",
              label: "企业简介",
              name: "intro"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  value: _ctx.form.intro,
                  "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.intro) = $event)),
                  placeholder: "请输入企业简介",
                  rows: "4"
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 512),
            _createVNode(_component_a_form_item, {
              ref: "name",
              label: "联系人",
              name: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.form.name,
                  "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.name) = $event)),
                  placeholder: "请输入联系人"
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 512),
            _createVNode(_component_a_form_item, {
              ref: "mobile",
              label: "手机号码",
              name: "mobile"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.form.mobile,
                  "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.mobile) = $event)),
                  placeholder: "请输入手机号码"
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 512),
            _createVNode(_component_a_form_item, {
              ref: "sex",
              label: "性别",
              name: "sex"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: _ctx.form.sex,
                  "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.sex) = $event)),
                  placeholder: "请选择性别"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: "0" }, {
                      default: _withCtx(() => [
                        _hoisted_37
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: "1" }, {
                      default: _withCtx(() => [
                        _hoisted_38
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: "2" }, {
                      default: _withCtx(() => [
                        _hoisted_39
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }, 512),
            _createVNode(_component_a_form_item, {
              ref: "qualifications",
              label: "持有资质"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.form.qualifications,
                  "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.qualifications) = $event)),
                  placeholder: "请输入持有资质"
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 512),
            _createVNode(_component_a_form_item, {
              ref: "contact_time",
              label: "上次联系时间"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_date_picker, {
                  value: _ctx.form.contact_time,
                  "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form.contact_time) = $event)),
                  format: "YYYY/MM/DD",
                  style: {"width":"100%"}
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 512),
            _createVNode(_component_a_form_item, {
              ref: "post",
              label: "职务"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.form.post,
                  "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.post) = $event)),
                  placeholder: "请输入职务"
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 512),
            _createVNode(_component_a_form_item, {
              ref: "recommender",
              label: "推荐人"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.form.recommender,
                  "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.form.recommender) = $event)),
                  placeholder: "请输入推荐人"
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 512),
            _createVNode(_component_a_form_item, {
              ref: "join_time",
              label: "入会时间"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_date_picker, {
                  value: _ctx.form.join_time,
                  "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form.join_time) = $event)),
                  format: "YYYY/MM/DD",
                  style: {"width":"100%"}
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 512),
            _createVNode(_component_a_form_item, {
              ref: "remark",
              label: "备注"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.form.remark,
                  "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.form.remark) = $event)),
                  placeholder: "请输入备注"
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 512)
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["title", "visible"])
  ], 64))
}